module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover5-ca834e2915951b8c89258407bd9e84e4.jpg";